import React from "react";
import {LoadingMessage} from "./controls";
import {useLocalization} from "@smalox/shared";

export function LoginPending() {
	const {t} = useLocalization();
	return <LoadingMessage message={t("login.loggingYouIn")} />;
}
